import { MfsStatusCode } from '@metaos/mfs-telemetry';
import { MfsFolderError } from './mfsFolderError';
/**
 * The client does not have access rights to the content; that is,
 * it is unauthorized, so the server is refusing to give the requested resource.
 * Unlike 401 Unauthorized, the client's identity is known to the server.
 * HTTP Response Status Code 403
 *
 * @param message The message that will be returned to the user
 * @param eventName Identification of the event that triggered the error
 */
export class Forbidden extends MfsFolderError {
    constructor(message, eventName) {
        super(message !== null && message !== void 0 ? message : `Forbidden`, false, eventName !== null && eventName !== void 0 ? eventName : 'Forbidden', MfsStatusCode.Forbidden);
    }
}
//# sourceMappingURL=forbidden.js.map